// src/components/admin/contact/ContactDetail.jsx
import React, { useState } from 'react';
import { FiX, FiMail, FiPhone, FiCalendar, FiMapPin, FiHome } from 'react-icons/fi';
import Modal from '../../common/Modal';
import Button from '../../common/Button';
import { formatDate } from '../../../utils/formatters';

const ContactDetail = ({ 
  contact, 
  onClose, 
  onStatusUpdate, 
  onDelete 
}) => {
  const [reply, setReply] = useState('');
  const [showReplyForm, setShowReplyForm] = useState(false);

  const getStatusBadge = (status) => {
    const statusConfig = {
      new: { color: 'bg-red-100 text-red-800', label: 'Baru' },
      read: { color: 'bg-blue-100 text-blue-800', label: 'Dibaca' },
      replied: { color: 'bg-green-100 text-green-800', label: 'Dibalas' },
      closed: { color: 'bg-gray-100 text-gray-800', label: 'Ditutup' }
    };

    const config = statusConfig[status] || statusConfig.new;
    return (
      <span className={`px-3 py-1 rounded-full text-sm font-medium ${config.color}`}>
        {config.label}
      </span>
    );
  };

  const handleStatusChange = (newStatus) => {
    onStatusUpdate(contact.id, newStatus);
  };

  const handleReply = () => {
    // In a real app, you would send the reply via email or save it
    console.log('Reply:', reply);
    handleStatusChange('replied');
    setShowReplyForm(false);
    setReply('');
  };

  const handleDelete = () => {
    if (window.confirm('Yakin ingin menghapus pesan ini?')) {
      onDelete(contact.id);
      onClose();
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose} size="lg">
      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Detail Pesan Kontak
            </h2>
            {getStatusBadge(contact.status)}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <FiX className="h-6 w-6" />
          </button>
        </div>

        {/* Contact Info */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-gray-900 mb-3">Informasi Pengirim</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <FiMail className="h-4 w-4 text-gray-500" />
              <span className="text-sm">
                <strong>{contact.name}</strong> - {contact.email}
              </span>
            </div>
            {contact.phone && (
              <div className="flex items-center gap-2">
                <FiPhone className="h-4 w-4 text-gray-500" />
                <span className="text-sm">{contact.phone}</span>
              </div>
            )}
            <div className="flex items-center gap-2">
              <FiCalendar className="h-4 w-4 text-gray-500" />
              <span className="text-sm">{formatDate(contact.created_at)}</span>
            </div>
            {contact.property_id && (
              <div className="flex items-center gap-2">
                <FiHome className="h-4 w-4 text-gray-500" />
                <span className="text-sm">Villa ID: {contact.property_id}</span>
              </div>
            )}
          </div>
        </div>

        {/* Message */}
        <div className="mb-6">
          <h3 className="font-semibold text-gray-900 mb-2">Subject</h3>
          <p className="text-gray-800 mb-4">{contact.subject}</p>
          
          <h3 className="font-semibold text-gray-900 mb-2">Pesan</h3>
          <div className="bg-white border rounded-lg p-4">
            <p className="text-gray-800 whitespace-pre-wrap">{contact.message}</p>
          </div>
        </div>

        {/* Reply Form */}
        {showReplyForm && (
          <div className="mb-6">
            <h3 className="font-semibold text-gray-900 mb-2">Balas Pesan</h3>
            <textarea
              value={reply}
              onChange={(e) => setReply(e.target.value)}
              rows={4}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Tulis balasan Anda..."
            />
            <div className="flex gap-2 mt-3">
              <Button onClick={handleReply}>
                Kirim Balasan
              </Button>
              <Button 
                variant="outline" 
                onClick={() => setShowReplyForm(false)}
              >
                Batal
              </Button>
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex flex-wrap gap-3 pt-4 border-t">
          {!showReplyForm && (
            <Button onClick={() => setShowReplyForm(true)}>
              Balas Pesan
            </Button>
          )}
          
          <select
            value={contact.status}
            onChange={(e) => handleStatusChange(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="new">Baru</option>
            <option value="read">Dibaca</option>
            <option value="replied">Dibalas</option>
            <option value="closed">Ditutup</option>
          </select>

          <Button 
            variant="outline" 
            onClick={handleDelete}
            className="text-red-600 hover:text-red-700 ml-auto"
          >
            Hapus Pesan
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ContactDetail;